import React, { useState } from "react";
import "../../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import MenuBlock from "./MenuBlock/MenuBlock";
import PartnersBlock from "./PartnersBlock/PartnersBlock";
import InfoTemplate from "./InfoTemplate/InfoTemplate";
import s from "./manual.module.css";
import {useTranslation} from "react-i18next";

/**
 * @param {'tenant' | 'building'} mode
 * */
export function ManualComponent({ mode }) {
  const { t } = useTranslation();
  document.title = t('titles.bank_charge_guide');

  const [activeTab, setActiveTab] = useState(1);
  const [activeBank, setActiveBank] = useState(null);
  const [finalPage, setFinalPage] = useState(false);

  const handleActiveTab = (value) => {
    switch (value) {
      case "1":
        setActiveTab(1);
        break;
      case "0":
        setActiveTab(0);
        break;
      default:
        setActiveTab(1);
    }
  };

  const handleBankSelect = (selectedBank) => {
    setActiveBank(selectedBank);
  };

  if (activeBank && !finalPage) {
    return (
      <section className={`container ${s.manual}`}>
        <InfoTemplate
          bank={activeBank}
          setActiveBank={setActiveBank}
          setFinalPage={setFinalPage}
          typeOfUpload={mode === 'tenant' ? 'bank-charge-permission' : 'building-bank-charge-permission'}
        />
      </section>
    );
  } else if (!activeBank && !finalPage) {
    return (
      <section className={`container ${s.manual}`}>
        {activeTab ? (
          <MenuBlock onChangeValue={handleActiveTab} />
        ) : (
          <PartnersBlock
            onChangeValue={handleActiveTab}
            onBankSelect={handleBankSelect}
          />
        )}
      </section>
    );
  } else if (activeBank && finalPage) {
    return (
      <section className={`container ${s.manual}`}>
        <h2>Final Page!</h2>
      </section>
    );
  }
}
